// src/i18n.js
// Internationalization configuration using react-i18next

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import en from "./locales/en/common.json";
import ru from "./locales/ru/common.json";
import tg from "./locales/tg/common.json";
import es from "./locales/es/common.json";
import ptBR from "./locales/pt-BR/common.json";
import vi from "./locales/vi/common.json";

const resources = {
  en: { translation: en },
  ru: { translation: ru },
  tg: { translation: tg },
  es: { translation: es },
  "pt-BR": { translation: ptBR },
  vi: { translation: vi },
};

i18n
  .use(LanguageDetector) // Detect browser language
  .use(initReactI18next) // Pass i18n to react-i18next
  .init({
    resources,
    supportedLngs: ["en", "ru", "tg", "es", "pt-BR", "vi"],
    // Do NOT add `nonExplicitSupportedLngs: true` — that option strips
    // the region tag before checking supportedLngs, which rejects
    // 'pt-BR' from the resolution chain (since bare 'pt' is not in the
    // list) and causes raw keys to render. Region variants of supported
    // languages (en-US, es-MX, vi-VN, etc.) are already collapsed to
    // their parent by toResolveHierarchy's language-only step.
    // Per-language fallback chains: pt and pt-PT route to pt-BR
    // (closest supported parent) instead of the default English fallback.
    fallbackLng: { pt: ["pt-BR"], "pt-PT": ["pt-BR"], default: ["en"] },
    debug: process.env.NODE_ENV === "development",

    interpolation: {
      escapeValue: false, // React already escapes
    },

    detection: {
      // Order of language detection
      order: ["localStorage", "navigator"],
      // Cache user language preference
      caches: ["localStorage"],
      lookupLocalStorage: "kbquick-language",
    },
  });

export default i18n;
